import React, {
    ReactElement,
    Component,
    useEffect,
    useContext,
    useState,
    Dispatch,
    SetStateAction,
    useRef,
    useCallback,
    useMemo
} from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Col, Row } from "antd";
import '../backup.less';
import TableList from "../../../../components/new-table-list/table-list";
import { operation_type, result_args_type } from '../../../../components/new-table-list/interface';
import { top_navbar_type, TopNavbarContext } from '../../contexts/top-navbar';
import { item_type, TableListContext, table_list_type } from "../../contexts/table-list";
import { get_db } from '../../../../http-worker/db-func';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
// eslint-disable-next-line
import { destroy_worker, http_request_new } from '../../../../http-worker/http-func';
import { response_type, post_processes_args_default } from '../../../../http-worker/function/interfaces';
import get_time from "../../../../shared-functions/get-time";
import get_name from "../../../../shared-functions/get-name";
import set_name from "../../../../shared-functions/set-name";
import { IUserInfoType, UserInfoContext } from "../../../../contexts/user-info";
import Cookies from "universal-cookie";
import { Option } from 'rc-select';
import { storage_settings_operation } from "./storage_settings.operation";
import { modal_type } from '../backup/backup.operation';
import { useDeepCompareEffect, useDeepCompareMemo } from 'use-deep-compare';
import { DatacenternameContext } from '../../../../contexts/datacenter-name';
import { NoPermissionVisibleContext } from '../../contexts/no-permission-visible';
import NoPermissionModal from '../../component/no-permission-modal';
import { LangContext } from '../../../../contexts/lang';
import {SubscriptionSelectedContext} from "../../contexts/subscription-selected";
import {http_get} from "../../common-file/service";

export function storage_settings_post_process({ response, resolve }: post_processes_args_default) {
    (response as any)?.items?.forEach((response_each: response_type) => {
        (response_each as any).storage_name = (response_each as any)?.db_storage?.name;
        (response_each as any).id = (response_each as any)?.db_storage?.id;
        // API 返回数据 name 可能为空，故暂用 id
        (response_each as any).name = (response_each as any)?.db_storage?.name;
        (response_each as any).storage_type = (response_each as any)?.storage_device?.type;
        (response_each as any).subscription_name = (response_each as any)?.subscription_id;
        delete (response_each as any)?.subscription_id;
    });
    resolve(response);
}

export const set_array = (key_array: string[], set_context: React.Dispatch<React.SetStateAction<any>>) => {
    const get_array_new: { [key: string]: (value: any) => void } = {};
    key_array?.forEach((key: string) => {
        get_array_new[`set_${key}`] = (value: any) => {
            set_context((currentState: any): any => ({
                ...currentState,
                [key]: value
            }));
        };
    });
    return get_array_new;
};

export const subscriptions_change = (event: string, format_subscriptions: any, set_sso_subscription_selected: any) => {
    if (event === 'all') {
        set_sso_subscription_selected({ subscription_id: 'all' })
    } else {
        // onChange && onChange();
        const subscription_id_new: any = (
            format_subscriptions?.find(({ id }: any) => id === event) || (format_subscriptions || [])[0]
        );
        if (subscription_id_new?.id) {
            new Cookies().set("service_subscription_id", subscription_id_new?.id, {
                domain: document?.domain?.substr(document?.domain?.indexOf(".")),
                path: "/",
            });
            set_sso_subscription_selected({ ...subscription_id_new, subscription_id: subscription_id_new?.id });
        }
    }
}

export interface storage_type {
    name: string,
    storage_type: string,
}

const BackupRestore: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {
    // eslint-disable-next-line
    const { formatMessage } = props?.intl,
      [storage_settings_list, set_storage_settings_list]: [item_type[] | undefined, Dispatch<SetStateAction<item_type[] | undefined>>] = useState<item_type[] | undefined>(),
      [item_selected, set_item_selected]: [item_type | undefined, Dispatch<SetStateAction<item_type | undefined>>] = useState<item_type | undefined>(),
      [action_id, set_action_id]: [number | undefined, React.Dispatch<React.SetStateAction<number | undefined>>] = useState<number | undefined>(),
      [visible, set_visible]: [1 | undefined, React.Dispatch<React.SetStateAction<1 | undefined>>] = useState<1 | undefined>(),
      set_no_permission_visible: Dispatch<SetStateAction<boolean>> = useContext(NoPermissionVisibleContext)[1],
      [table_list, set_table_list]: [table_list_type, React.Dispatch<React.SetStateAction<table_list_type>>] = useContext(TableListContext),
      [connection_status, set_connection_status]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
      [connect_loading, set_connect_loading]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
      table_list_array = useRef(set_array(['storage_settings_list'], set_table_list)),
      [action, set_action]: [modal_type['action'] | undefined, React.Dispatch<React.SetStateAction<modal_type['action'] | undefined>>] = useState<modal_type['action'] | undefined>(),
      [filter_operations, set_filter_operations]: [operation_type[] | undefined, Dispatch<SetStateAction<operation_type[] | undefined>>] = useState<operation_type[] | undefined>([]),
      path = props?.history?.location?.pathname?.substring(props?.history?.location?.pathname?.lastIndexOf("/") + 1),
      top_navbar: top_navbar_type = useContext(TopNavbarContext)[0],
      [format_subscriptions, set_format_subscriptions]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
      [selected_subscriptions, set_selected_subscriptions]: [string, React.Dispatch<React.SetStateAction<string>>] = useState<string>(""),
      user_info: IUserInfoType = useContext(UserInfoContext)[0],
      storage_type_list: React.MutableRefObject<{ name: string, storage_type: string }[]> = useRef([
          {name: "NFS", storage_type: "nfs"}
      ]),
      [loading_done, set_loading_done]: [{ [key: string]: 0 | 1 }, React.Dispatch<React.SetStateAction<{ [key: string]: 0 | 1 }>>] = useState<{
          [key: string]: 0 | 1;
      }>({}),
      {storage_type, subscription_name}: table_list_type = useDeepCompareMemo(() => table_list, [table_list]),
      props_new = useMemo(() => ({history: props?.history, location: props?.location, match: props?.match}), [
          props?.history,
          props?.location,
          props?.match,
      ]),
      lang: string = useContext(LangContext)[0],
      [search_value, set_search_value]: [table_list_type['search_value'], React.Dispatch<React.SetStateAction<table_list_type['search_value']>>] = useState<table_list_type['search_value']>(''),
      // 將各請求填成一個陣列
      request_array = useRef([
          {
              key: 'storage_settings',
              func: table_list_array?.current?.set_storage_settings_list,
              post_process: storage_settings_post_process
          }
      ]),
      cookie = new Cookies(),
      datacenter_name: string | undefined = useContext(DatacenternameContext)[0],
      sso_api_path = "/v4.0",
      [sso_subscriptions, set_sso_subscriptions]: [any, Dispatch<SetStateAction<any>>] = useState([]),
      [sso_subscription_selected, set_sso_subscription_selected]: [any, Dispatch<SetStateAction<any>>] = useContext(SubscriptionSelectedContext);

    // 離開頁面前銷毀所有 web worker
    useEffect(() => () => {
        table_list_array?.current?.set_storage_settings_list(undefined);
        destroy_worker();
    }, []);

    // 從 IndexedDB 拿所有資料
    useEffect((): void => {
        get_db(request_array?.current);
    }, []);

    useDeepCompareEffect((): void => {
        set_name('backup_search', search_value || '', set_table_list);
    }, [search_value]);

    useDeepCompareEffect((): void => {
        !loading_done?.storage_settings && sso_subscription_selected && !!Object.keys(sso_subscription_selected)?.length && subscription_name && http_request_new({
            key: 'storage_settings',
            props: props_new,
            func: set_storage_settings_list,
            url: `/backup/dbStorages${subscription_name === "all" && !storage_type ? '' :
                `?${subscription_name === "all" ? `storageDeviceType=${storage_type?.toLowerCase()}` :
                    !storage_type ? `subscriptionId=${subscription_name}` : `subscriptionId=${subscription_name}&storageDeviceType=${storage_type.toLowerCase()}`
                }`}`,
            method: 0,
            post_process: storage_settings_post_process,
            set_loading_done
        }).finally(()=> set_loading_done((current: any)=> ({
          ...current,
          storage_settings: 1
        })));
        // eslint-disable-next-line
    }, [props_new, loading_done?.storage_settings, storage_type, subscription_name, set_loading_done])

    useEffect(() => {
        set_filter_operations(storage_settings_operation());
    }, [path])

    useEffect((): void => {
        set_name('subscription_name', sso_subscription_selected?.subscription_id, set_table_list);
        // !table_list.subscription_name && user_info.ssoRole !== "globalAdmin" && set_name('subscription_name', sso_subscription_selected.subscription_id || "all", set_table_list);
        // set_name('storage_type', storage_type_list.length === 1 ? storage_type_list[0].name : "", set_table_list);
        set_name('storage_type', "", set_table_list);
        get_name('storage_type', table_list, set_table_list, storage_type_list?.current);
        get_name('subscription_name', table_list, set_table_list, format_subscriptions);
        // eslint-disable-next-line 
    }, [set_table_list, format_subscriptions, user_info, sso_subscription_selected, storage_type_list?.current]);

    useEffect(() => {
        if (datacenter_name && sso_api_path && props && user_info?.ssoRole) {
            set_sso_subscription_selected(null);
            (async () => {
                if (user_info?.ssoRole === "globalAdmin") {
                    // /v4.0/subscriptions?maxResults=999
                    const sso_subscription: any = await http_get(`/v4.0/subscriptions?maxResults=9999&page=&direction=&property=`, props) || {};
                    set_sso_subscriptions(sso_subscription?.data?.resources || []);
                    if (!(sso_subscription?.data?.resources?.length > 0)) set_no_permission_visible(true);
                } else {
                    // /v4.0/users/me
                    const sso_subscription: any = await http_get(`${sso_api_path}/users/me`,props);
                    set_sso_subscriptions(sso_subscription?.data?.userSubscriptions || []);
                    if (!(sso_subscription?.data?.userSubscriptions?.length > 0)) set_no_permission_visible(true);
                }
            })()
        }
        // eslint-disable-next-line
    }, [user_info?.ssoRole, path, datacenter_name, sso_api_path, set_sso_subscription_selected, set_sso_subscriptions, set_no_permission_visible]);

    useEffect(() => {
        if (sso_subscriptions?.length && user_info?.ssoRole) {
            const subscription_cookie: any = cookie.get('service_subscription_id'),
                subscription_new: any = sso_subscriptions?.find(({ subscriptionId, id }: any) => subscription_cookie && (subscriptionId === subscription_cookie || id === subscription_cookie));
            if (subscription_new) {
                set_sso_subscription_selected({ ...subscription_new, subscription_id: subscription_new?.subscriptionId || subscription_new?.id })
            } else {
                if (user_info?.ssoRole === 'globalAdmin') {
                    set_sso_subscription_selected({ subscription_id: 'all' })
                } else {
                    const new_selected = (sso_subscriptions || [])[0] || {};
                    set_sso_subscription_selected({
                        ...new_selected,
                        subscription_id: new_selected?.subscriptionId
                    });
                }
            }
        }
        // eslint-disable-next-line
    }, [sso_subscriptions, set_sso_subscription_selected, user_info?.ssoRole]);

    useEffect(() => {
        table_list?.subscription_name && set_selected_subscriptions(table_list?.subscription_name);
    }, [table_list?.subscription_name])

    useEffect((): void => {
        let subscriptions: any[] = [];
        sso_subscriptions?.length && sso_subscriptions?.map((item: any) => {
            return subscriptions?.push({
                id: item.subscriptionId || item?.id,
                name: item.subscriptionName || item?.name,
                company: item?.company,
                role: item.subscriptionRole || item?.role
            })
        })
        set_format_subscriptions(subscriptions);
    }, [sso_subscriptions])

    useEffect((): void => {
        format_subscriptions?.length && set_storage_settings_list((currentState: item_type[] | undefined) => {
            currentState?.map(item => {
                item.company = format_subscriptions?.filter(({ id }) => id === item?.subscription_name)?.[0]?.company
                return item
            });
            return currentState
        })
    }, [format_subscriptions, storage_settings_list])

    const result_to_do = useCallback((args: result_args_type) => {
        args?.props?.action === 2 && set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
            ...current_state,
            storage_settings: 0
        }));
    }, [])

    return (
        <Col span={24}>
            <Col span={24} className="px-20 backup_cell">
                {<TableList
                    operations={storage_settings_operation}
                    {...top_navbar?.table_list_array}
                    {...{
                        table_desc: [formatMessage({ id: "storage_settings" })],
                        titles: sso_subscription_selected?.subscription_id === "all" ?
                            ['subscription_name', 'company', 'storage_name', 'storage_type', 'description', 'created_time', 'edit', 'delete'] :
                            ['storage_name', 'storage_type', 'description', 'created_time', 'edit', 'delete'],
                        items: storage_settings_list || (!subscription_name ? [] : undefined),
                        set_items: set_storage_settings_list,
                        set_storage_settings_list,
                        path: "storage_settings",
                        custom_col: {
                            created_time: (item: number) => get_time(item),
                            storage_type: (item: string) => item === "nfs" ? item.toUpperCase() : item,
                            subscription_name: (_item: any, record: any) => format_subscriptions?.filter(({ id }) => id === record?.subscription_name)?.[0]?.name,
                            company: (_item: any, record: any) => format_subscriptions?.filter(({ id }) => id === record?.subscription_name)?.[0]?.company,
                            edit: (_item: any, record: any) => {
                                return <EditOutlined
                                    className="row-icon"
                                    onClick={() => {
                                        set_item_selected(record);
                                        set_action_id(1);
                                        set_action(1);
                                        set_visible(1);
                                    }} />
                            },
                            delete: (_item: any, record: any) => {
                                return <DeleteOutlined
                                    className="row-icon"
                                    onClick={() => {
                                        set_item_selected(record);
                                        set_action_id(2);
                                        set_action(2);
                                        set_visible(1);
                                    }} />
                            },
                            storage_name: (name: string, record: any) => {
                                return <span className="pointer backup-name-color" title={name}
                                    onClick={() => {
                                        set_item_selected(record);
                                        set_action_id(3);
                                        set_visible(1);
                                    }}>
                                    {name}
                                </span>
                            },
                        },
                        item_selected,
                        set_item_selected,
                        filter_operations,
                        visible,
                        set_visible,
                        action,
                        set_action,
                        action_id,
                        set_action_id,
                        subscription_id: table_list?.subscription_name,
                        storage_type: table_list?.storage_type,
                        connection_status,
                        set_connection_status,
                        storage_type_list: storage_type_list?.current,
                        format_subscriptions,
                        selected_subscriptions,
                        user_info,
                        sso_subscription_selected,
                        set_sso_subscription_selected,
                        connect_loading,
                        set_connect_loading,
                        please_input_name: "storage_backup",
                        loading_done,
                        set_loading_done,
                        no_sort_col: ["edit", "delete"],
                        result_to_do,
                        lang,
                        search_value,
                        set_search_value,
                        no_create_button: subscription_name ? undefined : 1,
                        no_refresh_button: subscription_name ? undefined : 1,
                        set_loading_done_items: () => {
                            set_loading_done((current_state: { [key: string]: 0 | 1 }) => ({
                                ...current_state,
                                storage_settings: 0
                            }));
                        },
                        dropdown_menus: [
                            {
                                width: 6,
                                list: format_subscriptions,
                                caption: "subscription_name",
                                value: sso_subscription_selected?.subscription_id,
                                has_all: user_info?.ssoRole === "globalAdmin" ? 1 : undefined,
                                change_event: (event: string) => {
                                    set_table_list((current_state: table_list_type) => ({
                                        ...current_state,
                                        subscription_name: event
                                    }));
                                    // set_name('subscription_name', event, set_table_list);
                                    subscriptions_change(event, format_subscriptions, set_sso_subscription_selected);
                                },
                                dropdown_menu_element: (id: string, name: string) => {
                                    let company: string = format_subscriptions?.length && format_subscriptions?.filter((item: { id: string; name: string; }) => {
                                        return item.id === id && item.name === name
                                    })?.[0]?.company;
                                    return [
                                        <Option
                                            // key={id ?? "all"}
                                            key={`${name} ${company}` ?? "all"}
                                            value={id ?? "all"}>
                                            {(!id && user_info?.ssoRole === "globalAdmin") ?
                                                formatMessage({ id: 'all_subscription' }) :
                                                <Row
                                                    title={
                                                        formatMessage({ id: "subscription_name" }) +
                                                        ": " +
                                                        name +
                                                        "        " +
                                                        formatMessage({ id: "company" }) +
                                                        ": " +
                                                        company
                                                    }
                                                >
                                                    <Col lg={9} md={10} sm={11} xs={12} className="font-w-6 text-ellipsis">
                                                        {name}
                                                    </Col>
                                                    <Col lg={13} md={12} sm={11} xs={10} className="ml-10 text-ellipsis">
                                                        {company}
                                                    </Col>
                                                </Row>}
                                        </Option>]
                                }
                            }, {
                                list: storage_type_list?.current,
                                caption: "storage_type",
                                value: table_list?.storage_type,
                                change_event: (event: string) => {
                                    set_table_list((current_state: table_list_type) => ({
                                        ...current_state,
                                        storage_type: event
                                    }));
                                    sessionStorage.setItem('storage_type', event);
                                },
                                // has_all: storage_type_list?.length > 1 ? 1 : undefined,
                                has_all: 1
                            }
                        ]
                    }} />}
            </Col>
            <NoPermissionModal />
        </Col>
    )

};

export default injectIntl(withRouter(BackupRestore) as any);
